import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { MdDelete } from 'react-icons/md';
import fetchMolduras from '../../services/Logo_Moldura/fetchMolduras';
import ThumbnailViewer from '../../services/Logo_Moldura/ThumbnailViewer';

const GalleryContainer = styled.div`
  margin-top: 20px;
  padding: 10px;
`;

const GalleryTitle = styled.h3`
  font-size: 16px;
  margin-bottom: 15px;
`;

const ThumbnailGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

const ThumbnailContainer = styled.div`
  position: relative;
  margin: 10px;
`;

const DeleteButton = styled.button`
  position: absolute;
  top: 5px;
  right: 5px;
  background: none;
  border: none;
  color: #ff0000;
  cursor: pointer;
  font-size: 20px;
  padding: 5px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: all 0.2s;

  &:hover {
    background-color: rgba(255, 0, 0, 0.1);
    transform: scale(1.1);
  }
`;

const EmptyMessage = styled.p`
  color: #666;
  font-style: italic;
  padding: 20px;
  text-align: center;
  width: 100%;
`;

const LoadingMessage = styled.div`
  text-align: center;
  padding: 20px;
  color: #666;
`;

const ErrorMessage = styled.div`
  color: #d32f2f;
  padding: 15px;
  background-color: #ffebee;
  border-radius: 4px;
  margin-bottom: 15px;
`;

const MoldurasGallery = ({ idRede, onSelectMoldura, onDeleteMoldura }) => {
  const [molduras, setMolduras] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const loadMolduras = async () => {
      if (!idRede) {
        setMolduras([]);
        return;
      }
      
      setLoading(true);
      setError(null);
      
      try {
        const result = await fetchMolduras(idRede);
        
        if (result.success) {
          setMolduras(result.molduras);
        } else {
          setError(result.message || 'Erro ao carregar molduras');
          setMolduras([]);
        }
      } catch (err) {
        console.error('Erro ao buscar molduras:', err);
        setError('Erro ao carregar molduras. Tente novamente.');
        setMolduras([]);
      } finally {
        setLoading(false);
      }
    };
    
    loadMolduras();
  }, [idRede]);
  
  const handleThumbnailClick = (moldura) => {
    if (onSelectMoldura) {
      onSelectMoldura(moldura);
    }
  };

  const handleDelete = (e, nomeArquivo) => {
    e.stopPropagation(); // Previne que o clique propague para o thumbnail
    if (onDeleteMoldura) {
      onDeleteMoldura(nomeArquivo);
    }
  };
  
  if (loading) {
    return <LoadingMessage>Carregando molduras...</LoadingMessage>;
  }
  
  return (
    <GalleryContainer>
      <GalleryTitle>Molduras Disponíveis</GalleryTitle>
      
      {error && <ErrorMessage>{error}</ErrorMessage>}
      
      <ThumbnailGrid>
        {molduras.length > 0 ? (
          molduras.map((moldura) => (
            <ThumbnailContainer key={moldura.id}>
              <ThumbnailViewer
                nomeArquivo={moldura.nome}
                idRede={idRede}
                onClick={() => handleThumbnailClick(moldura)}
              />
              <DeleteButton 
                onClick={(e) => handleDelete(e, moldura.nome)}
                title="Excluir moldura"
              >
                <MdDelete />
              </DeleteButton>
            </ThumbnailContainer>
          ))
        ) : (
          <EmptyMessage>
            {!error && 'Nenhuma moldura encontrada para esta rede.'}
          </EmptyMessage>
        )}
      </ThumbnailGrid>
    </GalleryContainer>
  );
};

export default MoldurasGallery;